import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import { AdPlacementSectionComponent } from './sections/ad-placement-section/ad-placement-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Umieszczenie reklamy',
  'Płatnik',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../umieszczenie-reklamy',
  cancelUrl: '../wnioskodawca',
  addApplicationSubjectControl: true,
  applicationSubjectControlType: 'select',
  applicationSubjectOptions: [
    'Wydanie zezwolenia',
    'Przedłużenie zezwolenia'
  ]
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../umieszczenie-reklamy',
  customTitles: {
    sectionTitle: 'Płatnik',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane płatnika',
      acceptLabel: 'Dane płatnika są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie płatnika',
    cardTitle2: 'Edytuj płatnika',
    addBtnTitle: 'Dodaj płatnika',
    addBtn2Title: 'Dodaj kolejnego płatnika',
    noDataInfo: 'Brak dodanych płatników!'
  }
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../inwestor',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const placementAdvertisingRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: contractorDataSectionConfig
  },
  {
    component: AdPlacementSectionComponent,
    path: ':appId/umieszczenie-reklamy'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
